import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'SSkeletonItem' },
  __name: 'SSkeletonItem',
  props: {
    loading: { type: Boolean, default: false },
    height: { default: '' }
  },
  setup(__props: any) {



const props = __props;

const skeletonHeight = computed(() => {
  if (props.height) {
    if (typeof props.height === 'number') {
      return `height:${props.height}px`;
    }
    if (typeof props.height === 'string') {
      return `height: ${props.height}`;
    }
  }
  return '';
});

return (_ctx: any,_cache: any) => {
  const _component_q_skeleton = _resolveComponent("q-skeleton")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_q_skeleton, {
          key: 0,
          class: "s-skeleton",
          type: "rect",
          animation: "fade",
          style: _normalizeStyle(skeletonHeight.value)
        }, null, 8, ["style"]))
      : _renderSlot(_ctx.$slots, "default", { key: 1 })
  ]))
}
}

})